const initGlobalConfig = () => {
    return Promise.all([
        import(/* webpackChunkName: "Store" */ 'store/store'),
        import(/* webpackChunkName: "GlobalConfigActions" */ 'actions/globalConfigActions'),
    ]).then(response => {
        const [ Store, GlobalConfigActions ] = response;

        const { store } = Store;
        const { requestGlobalConfig } = GlobalConfigActions;

        // Request global config
        return Promise.all([
            store.dispatch(requestGlobalConfig()),
        ]).then(() => {
            return response;
        });
    });
};
const initMainData = () => {
    Promise.all([
        import(
        // --------------
        // Core
        // --------------
        /* webpackChunkName: "React" */ 'react'),
        import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
        import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
        import(/* webpackChunkName: "Store" */ 'store/store'),
        import(/* webpackChunkName: "Reactl10n" */ 'react-l10n'),
        import(/* webpackChunkName: "MainLanguage" */ 'lang/main'),
        import(/* webpackChunkName: "ReactStripeElements" */ 'react-stripe-elements'),
        // --------------
        // Actions
        // --------------
        import(/* webpackChunkName: "UserActions" */ 'actions/userActions'),
        import(/* webpackChunkName: "CartActions" */ 'actions/cartActions'),
        import(/* webpackChunkName: "InStoreProductActions" */ 'actions/inStoreProductActions'),
        // --------------
        // Components
        // --------------
        import(/* webpackChunkName: "SelectDeliverySupplierModal" */ 'containers/SelectDeliverySupplierModalContainer'),
        import(/* webpackChunkName: "ReAuthenticatePasswordModalContainer" */ 'containers/ReAuthenticatePasswordModalContainer'),
        import(/* webpackChunkName: "CartModal" */ 'containers/CartModalContainer'),
        import(/* webpackChunkName: "CartSummary" */ 'containers/CartSummaryContainer'),
        import(/* webpackChunkName: "CartSummaryNoteForm" */ 'containers/CartSummaryNoteFormContainer'),
        import(/* webpackChunkName: "CheckoutForm" */ 'containers/CheckoutFormContainer'),
        import('containers/CheckoutConfirmationContainer'),
        import('containers/MyStoreReviewCustomerContainer'),
        import(/* webpackChunkName: "ProductList" */ 'containers/ProductListContainer'),
        import(/* webpackChunkName: "ProductListFilter" */ 'containers/ProductListFilterContainer'),
        import(/* webpackChunkName: "ProductVariationList" */ 'containers/ProductVariationListContainer'),
        import(/* webpackChunkName: "RelatedProductList" */ 'containers/RelatedProductListContainer'),
        import(/* webpackChunkName: "InStoreProductList" */ 'containers/InStoreProductListContainer'),
        import(/* webpackChunkName: "InStoreProductListFilter" */ 'containers/InStoreProductListFilterContainer'),
        import(/* webpackChunkName: "StoreLocator" */ 'components/StoreLocator'),
        import(/* webpackChunkName: "CustomerOrders" */ 'components/CustomerOrders'),
        import(/* webpackChunkName: "CustomerOrdersAwaitingResellerApproval" */ 'components/CustomerOrdersAwaitingResellerApproval'),
        import(/* webpackChunkName: "CustomerOrdersAwaitingApproval" */ 'components/CustomerOrdersAwaitingApproval'),
        import(/* webpackChunkName: "CustomerOrdersApproved" */ 'components/CustomerOrdersApproved'),
        import(/* webpackChunkName: "OrderItemsDetail" */ 'containers/OrderItemsDetailContainer'),
        import(/* webpackChunkName: "OrderUpdateFreight" */ 'containers/OrderUpdateFreightContainer'),
        import(/* webpackChunkName: "CustomerBackOrders" */ 'components/CustomerBackOrders'),
        import(/* webpackChunkName: "CustomerOrdersRejected" */ 'components/CustomerOrdersRejected'),
        import(/* webpackChunkName: "CustomerOrdersCustomerContacted" */ 'components/CustomerOrdersCustomerContacted'),
        import(/* webpackChunkName: "CustomerOrdersOnAccount" */ 'components/CustomerOrdersOnAccount'),
        import(/* webpackChunkName: "CustomerOrdersOnAccountPaymentReceived" */ 'components/CustomerOrdersOnAccountPaymentReceived'),
        import(/* webpackChunkName: "CustomerOrdersOnAccountPaymentSent" */ 'components/CustomerOrdersOnAccountPaymentSent'),
        import(/* webpackChunkName: "DispatchList" */ 'components/DispatchList'),
        import(/* webpackChunkName: "ManifestList" */ 'components/ManifestList'),
        import(/* webpackChunkName: "DispatchHistoryList" */ 'components/DispatchHistoryList'),
        import(/* webpackChunkName: "AccountDetailForm" */ 'containers/AccountDetailFormContainer'),
        import(/* webpackChunkName: "StripeDetailForm" */ 'containers/StripeDetailFormContainer'),
        import(/* webpackChunkName: "StripePayoutLogs" */ 'components/StripePayoutLogs'),
        import(/* webpackChunkName: "CustomerDetailForm" */ 'containers/CustomerDetailFormContainer'),
        import(/* webpackChunkName: "ReciprocalInvoiceList" */ 'components/InvoiceList/ReciprocalInvoiceList'),
        import(/* webpackChunkName: "ReportsContainer" */ 'containers/ReportsContainer'),
        import(/* webpackChunkName: "OrderDetailManager" */ 'containers/OrderDetailManagerContainer'),
        import(/* webpackChunkName: "ProductTagWizardDebugger" */ 'containers/ProductTagWizardDebuggerContainer'),
    ]).then((response) => {
        // Request global config first
        return Promise.all([
            initGlobalConfig(),
        ]).then(() => {
            return response;
        });
    }).then((response) => {
        const [
            // --------------
            // Core
            // --------------
            { default: React },
            { default: ReactDOM },
            ReactRedux,
            Store,
            { LocalizationProvider },
            { getResources },
            { Elements, StripeProvider },

            // --------------
            // Actions
            // --------------
            UserActions,
            CartActions,
            InStoreProductActions,

            // --------------
            // Components
            // --------------
            { default: SelectDeliverySupplierModal },
            { default: ReAuthenticatePasswordModal },
            { default: CartModal },
            { default: CartSummary },
            { default: CartSummaryNoteForm },
            { default: CheckoutForm },
            { default: CheckoutConfirmationContainer },
            { default: MyStoreReviewCustomerContainer },
            { default: ProductList },
            { default: ProductListFilter },
            { default: ProductVariationList },
            { default: RelatedProductList },
            { default: InStoreProductList },
            { default: InStoreProductListFilter },
            { default: StoreLocator },
            { default: CustomerOrders },
            { default: CustomerOrdersAwaitingResellerApproval },
            { default: CustomerOrdersAwaitingApproval },
            { default: CustomerOrdersApproved },
            { default: OrderItemsDetail },
            { default: OrderUpdateFreight },
            {default: CustomerBackOrders},
            { default: CustomerOrdersRejected },
            { default: CustomerOrdersCustomerContacted },
            { default: CustomerOrdersOnAccount },
            { default: CustomerOrdersOnAccountPaymentReceived },
            { default: CustomerOrdersOnAccountPaymentSent },
            { default: DispatchList },
            { default: ManifestList },
            { default: DispatchHistoryList },
            { default: AccountDetailForm },
            { default: StripeDetailForm },
            { default: StripePayoutLogs },
            { default: CustomerDetailForm },
            { default: ReciprocalInvoiceList },
            { default: ReportsContainer },
            { default: OrderDetailManager },
            { default: ProductTagWizardDebugger },
        ] = response;

        const { Provider } = ReactRedux;
        const { store } = Store;
        const {
            setMemberType,
            setMemberProductConfiguratorType,
            setLoggedIn,
            setOrderOnBehalf,
            requestInfo,
            requestInfoAccountDetail,
        } = UserActions;
        const { requestCart } = CartActions;
        const { updateInStoreProductCategoryFilter } = InStoreProductActions;

        // Setup current logged in user & current purchasing user
        store.dispatch(setMemberType(window.memberType || 'retail-customer'));
        store.dispatch(setMemberProductConfiguratorType(window.productConfiguratorType || ''));
        store.dispatch(setLoggedIn(window.loggedIn || false));
        store.dispatch(setOrderOnBehalf(window.orderOnBehalf || false));
        const queryString = window.location.href;

        if (queryString.includes('details')) {
            store.dispatch(requestInfoAccountDetail(0, 9999, '', 'complex'));
          } else {
            store.dispatch(requestInfo(0, 5, '', 'complex'));
          }


        // Request cart
        store.dispatch(requestCart());

        // Render Helper
        const renderElement = (domObject, reactElement) => {
            if (domObject) {
                ReactDOM.render(reactElement, domObject);
            }
        };

        // --------------
        // Render
        // --------------
        // General
        renderElement(
            document.getElementById('delivery-supplier-modal-content'),
            <LocalizationProvider resources={getResources()}>
                <Provider store={store}>
                    <SelectDeliverySupplierModal />
                </Provider>
            </LocalizationProvider>
        );
        renderElement(
            document.getElementById('re-authenticate-password-modal-content'),
            <LocalizationProvider resources={getResources()}>
                <Provider store={store}>
                    <ReAuthenticatePasswordModal />
                </Provider>
            </LocalizationProvider>
        );
        renderElement(
            document.getElementById('cart-modal'),
            <LocalizationProvider resources={getResources()}>
                <Provider store={store}>
                    <CartModal />
                </Provider>
            </LocalizationProvider>
        );
        renderElement(
            document.getElementById('cart-summary'),
            <LocalizationProvider resources={getResources()}>
                <Provider store={store}>
                    <CartSummary />
                </Provider>
            </LocalizationProvider>
        );
        renderElement(
            document.getElementById('cart-summary-note-form'),
            <LocalizationProvider resources={getResources()}>
                <Provider store={store}>
                    <CartSummaryNoteForm />
                </Provider>
            </LocalizationProvider>
        );
        renderElement(
            document.getElementById('checkout-payment-form'),
            <LocalizationProvider resources={getResources()}>
                <Provider store={store}>
                    <StripeProvider apiKey={window.stripePublicKey}>
                        <Elements>
                            <CheckoutForm />
                        </Elements>
                    </StripeProvider>
                </Provider>
            </LocalizationProvider>
        );
        renderElement(
            document.getElementById('checkout-confirmation-order-approval'),
            <LocalizationProvider resources={getResources()}>
                <Provider store={store}>
                    <CheckoutConfirmationContainer />
                </Provider>
            </LocalizationProvider>
        );
        renderElement(
            document.getElementById('my-store-reivew-customer'),
            <LocalizationProvider resources={getResources()}>
                <Provider store={store}>
                    <MyStoreReviewCustomerContainer />
                </Provider>
            </LocalizationProvider>
        );
        renderElement(
            document.getElementById('product-listing'),
            <LocalizationProvider resources={getResources()}>
                <Provider store={store}>
                    <ProductList />
                </Provider>
            </LocalizationProvider>
        );
        renderElement(
            document.getElementById('product-listing-filter'),
            <LocalizationProvider resources={getResources()}>
                <Provider store={store}>
                    <ProductListFilter />
                </Provider>
            </LocalizationProvider>
        );
        renderElement(
            document.getElementById('product-variation-list'),
            <LocalizationProvider resources={getResources()}>
                <Provider store={store}>
                    <ProductVariationList />
                </Provider>
            </LocalizationProvider>
        );
        renderElement(
            document.getElementById('related-products-slider'),
            <LocalizationProvider resources={getResources()}>
                <Provider store={store}>
                    <RelatedProductList />
                </Provider>
            </LocalizationProvider>
        );

        const inStoreProductListing = document.getElementById(
            'in-store-product-listing'
        );
        if (inStoreProductListing) {
            store.dispatch(
                updateInStoreProductCategoryFilter(
                    typeof window.categoryID != 'undefined'
                        ? window.categoryID
                        : 0
                )
            );
            renderElement(
                inStoreProductListing,
                <LocalizationProvider resources={getResources()}>
                    <Provider store={store}>
                        <InStoreProductList />
                    </Provider>
                </LocalizationProvider>
            );
        }
        renderElement(
            document.getElementById('in-store-product-listing-filter'),
            <LocalizationProvider resources={getResources()}>
                <Provider store={store}>
                    <InStoreProductListFilter />
                </Provider>
            </LocalizationProvider>
        );
        renderElement(
            document.getElementById('store-locator-area'),
            <LocalizationProvider resources={getResources()}>
                <Provider store={store}>
                    <StoreLocator />
                </Provider>
            </LocalizationProvider>
        );
        renderElement(
            document.getElementById('customer-orders'),
            <LocalizationProvider resources={getResources()}>
                <Provider store={store}>
                    <CustomerOrders />
                </Provider>
            </LocalizationProvider>
        );
        renderElement(
            document.getElementById('customer-orders-awaiting-reseller-approval'),
            <LocalizationProvider resources={getResources()}>
                <Provider store={store}>
                    <CustomerOrdersAwaitingResellerApproval />
                </Provider>
            </LocalizationProvider>
        );
        renderElement(
            document.getElementById('customer-orders-awaiting-approval'),
            <LocalizationProvider resources={getResources()}>
                <Provider store={store}>
                    <CustomerOrdersAwaitingApproval />
                </Provider>
            </LocalizationProvider>
        );
        renderElement(
            document.getElementById('customer-orders-approved'),
            <LocalizationProvider resources={getResources()}>
                <Provider store={store}>
                    <CustomerOrdersApproved />
                </Provider>
            </LocalizationProvider>
        );
        renderElement(
            document.getElementById('order-item-details'),
            <LocalizationProvider resources={getResources()}>
                <Provider store={store}>
                    <OrderItemsDetail />
                </Provider>
            </LocalizationProvider>
        );
        renderElement(
            document.getElementById('update-order-freight-section'),
            <LocalizationProvider resources={getResources()}>
                <Provider store={store}>
                    <OrderUpdateFreight />
                </Provider>
            </LocalizationProvider>
        );
        renderElement(
            document.getElementById('back-orders'),
            <LocalizationProvider resources={getResources()}>
                <Provider store={store}>
                    <CustomerBackOrders />
                </Provider>
            </LocalizationProvider>
        );

        renderElement(
            document.getElementById('customer-orders-rejected'),
            <LocalizationProvider resources={getResources()}>
                <Provider store={store}>
                    <CustomerOrdersRejected />
                </Provider>
            </LocalizationProvider>
        );
        renderElement(
            document.getElementById('customer-orders-contact-customer'),
            <LocalizationProvider resources={getResources()}>
                <Provider store={store}>
                    <CustomerOrdersCustomerContacted />
                </Provider>
            </LocalizationProvider>
        );
        renderElement(
            document.getElementById('customer-orders-on-account'),
            <LocalizationProvider resources={getResources()}>
                <Provider store={store}>
                    <CustomerOrdersOnAccount />
                </Provider>
            </LocalizationProvider>
        );
        renderElement(
            document.getElementById('customer-orders-on-account-payment-received'),
            <LocalizationProvider resources={getResources()}>
                <Provider store={store}>
                    <CustomerOrdersOnAccountPaymentReceived />
                </Provider>
            </LocalizationProvider>
        );
        renderElement(
            document.getElementById('customer-orders-on-account-payment-sent'),
            <LocalizationProvider resources={getResources()}>
                <Provider store={store}>
                    <CustomerOrdersOnAccountPaymentSent />
                </Provider>
            </LocalizationProvider>
        );
        renderElement(
            document.getElementById('dispatch-list'),
            <LocalizationProvider resources={getResources()}>
                <Provider store={store}>
                    <DispatchList />
                </Provider>
            </LocalizationProvider>
        );
        renderElement(
            document.getElementById('manifest-list'),
            <LocalizationProvider resources={getResources()}>
                <Provider store={store}>
                    <ManifestList />
                </Provider>
            </LocalizationProvider>
        );
        renderElement(
            document.getElementById('dispatch-history'),
            <LocalizationProvider resources={getResources()}>
                <Provider store={store}>
                    <DispatchHistoryList />
                </Provider>
            </LocalizationProvider>
        );
        renderElement(
            document.getElementById('account-detail-complete-form'),
            <LocalizationProvider resources={getResources()}>
                <Provider store={store}>
                    <AccountDetailForm />
                </Provider>
            </LocalizationProvider>
        );
        renderElement(
            document.getElementById('stripe-detail-complete-form'),
            <LocalizationProvider resources={getResources()}>
                <Provider store={store}>
                    <StripeDetailForm />
                </Provider>
            </LocalizationProvider>
        );
        renderElement(
            document.getElementById('stripe-payout-logs'),
            <LocalizationProvider resources={getResources()}>
                <Provider store={store}>
                    <StripePayoutLogs />
                </Provider>
            </LocalizationProvider>
        );

        // My Store Related
        const customerDetailForm = document.getElementById(
            'customer-detail-complete-form'
        );
        if (customerDetailForm) {
            renderElement(
                document.getElementById('customer-detail-complete-form'),
                <LocalizationProvider resources={getResources()}>
                    <Provider store={store}>
                        <CustomerDetailForm
                            id={customerDetailForm.getAttribute('data-id')}
                        />
                    </Provider>
                </LocalizationProvider>
            );
        }

        renderElement(
            document.getElementById('reciprocal-invoice-list'),
            <LocalizationProvider resources={getResources()}>
                <Provider store={store}>
                    <ReciprocalInvoiceList />
                </Provider>
            </LocalizationProvider>
        );

        renderElement(
            document.getElementById('reports'),
            <LocalizationProvider resources={getResources()}>
                <Provider store={store}>
                    <ReportsContainer />
                </Provider>
            </LocalizationProvider>
        );

        renderElement(
            document.getElementById('order-detail-manager'),
            <LocalizationProvider resources={getResources()}>
                <Provider store={store}>
                    <OrderDetailManager />
                </Provider>
            </LocalizationProvider>
        );

        // Helper to Debug Tag Wizard
        renderElement(
            document.getElementById('tag-wizard-debugger'),
            <LocalizationProvider resources={getResources()}>
                <Provider store={store}>
                    <ProductTagWizardDebugger />
                </Provider>
            </LocalizationProvider>
        );
    });
};
const initCoupons = () => {
    const el = document.getElementById('coupon-list');
    if (el) {
        Promise.all([
            import(/* webpackChunkName: "React" */ 'react'),
            import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
            import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
            import(/* webpackChunkName: "Store" */ 'store/store'),
            import(/* webpackChunkName: "CouponList" */ 'containers/CouponListContainer'),
            import(/* webpackChunkName: "TopNotificationBar" */ 'containers/CouponTopNotificationBarContainer'),
            import(/* webpackChunkName: "Reactl10n" */ 'react-l10n'),
            import(/* webpackChunkName: "MainLanguage" */ 'lang/main'),
        ]).then(
            ([
                { default: React },
                { default: ReactDOM },
                ReactRedux,
                Store,
                { default: CouponList },
                { default: TopNotificationBar },
                { LocalizationProvider },
                { getResources },
            ]) => {
                const { Provider } = ReactRedux;
                const { store } = Store;

                ReactDOM.render(
                    <LocalizationProvider resources={getResources()}>
                        <Provider store={store}>
                            <CouponList />
                        </Provider>
                    </LocalizationProvider>,
                    el
                );

                // Top Notification Bar
                let topNotificationBar = document.createElement('div');
                topNotificationBar.setAttribute(
                    'id',
                    'coupon-list-notification'
                );
                document.body.appendChild(topNotificationBar);

                ReactDOM.render(
                    <LocalizationProvider resources={getResources()}>
                        <Provider store={store}>
                            <TopNotificationBar />
                        </Provider>
                    </LocalizationProvider>,
                    topNotificationBar
                );
            }
        );
    }
};
const initCouponForm = () => {
    const el = document.getElementById('coupon-form');
    if (el) {
        Promise.all([
            import(/* webpackChunkName: "React" */ 'react'),
            import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
            import(/* webpackChunkName: "CouponForm" */ 'components/Coupon/CouponForm'),
            import(/* webpackChunkName: "Reactl10n" */ 'react-l10n'),
            import(/* webpackChunkName: "MainLanguage" */ 'lang/main'),
        ]).then(
            ([
                { default: React },
                { default: ReactDOM },
                { default: CouponForm },
                { LocalizationProvider },
                { getResources },
            ]) => {
                ReactDOM.render(
                    <LocalizationProvider resources={getResources()}>
                        <CouponForm />
                    </LocalizationProvider>,
                    el
                );
            }
        );
    }
};

const initReferralCoupons = () => {
    const el = document.getElementById('referral-coupon-list');
    if (el) {
        Promise.all([
            import(/* webpackChunkName: "React" */ 'react'),
            import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
            import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
            import(/* webpackChunkName: "Store" */ 'store/store'),
            import(/* webpackChunkName: "CouponList" */ 'containers/ReferralCouponListContainer'),
            import(/* webpackChunkName: "TopNotificationBar" */ 'containers/ReferralCouponTopNotificationBarContainer'),
            import(/* webpackChunkName: "Reactl10n" */ 'react-l10n'),
            import(/* webpackChunkName: "MainLanguage" */ 'lang/main'),
        ]).then(
            ([
                { default: React },
                { default: ReactDOM },
                ReactRedux,
                Store,
                { default: ReferralCouponList },
                { default: TopNotificationBar },
                { LocalizationProvider },
                { getResources },
            ]) => {
                const { Provider } = ReactRedux;
                const { store } = Store;

                ReactDOM.render(
                    <LocalizationProvider resources={getResources()}>
                        <Provider store={store}>
                            <ReferralCouponList />
                        </Provider>
                    </LocalizationProvider>,
                    el
                );

                // Top Notification Bar
                let topNotificationBar = document.createElement('div');
                topNotificationBar.setAttribute(
                    'id',
                    'referral-coupon-list-notification'
                );
                document.body.appendChild(topNotificationBar);

                ReactDOM.render(
                    <LocalizationProvider resources={getResources()}>
                        <Provider store={store}>
                            <TopNotificationBar />
                        </Provider>
                    </LocalizationProvider>,
                    topNotificationBar
                );
            }
        );
    }
};
const initReferralCouponForm = () => {
    const el = document.getElementById('referral-coupon-form');
    if (el) {
        Promise.all([
            import(/* webpackChunkName: "React" */ 'react'),
            import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
            import(/* webpackChunkName: "CouponForm" */ 'components/ReferralCoupon/ReferralCouponForm'),
            import(/* webpackChunkName: "Reactl10n" */ 'react-l10n'),
            import(/* webpackChunkName: "MainLanguage" */ 'lang/main'),
        ]).then(
            ([
                { default: React },
                { default: ReactDOM },
                { default: ReferralCouponForm },
                { LocalizationProvider },
                { getResources },
            ]) => {
                ReactDOM.render(
                    <LocalizationProvider resources={getResources()}>
                        <ReferralCouponForm />
                    </LocalizationProvider>,
                    el
                );
            }
        );
    }
};

const initInStoreProductManager = () => {
    const el = document.getElementById('in-store-products');
    if (el) {
        Promise.all([
            import(/* webpackChunkName: "React" */ 'react'),
            import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
            import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
            import(/* webpackChunkName: "Store" */ 'store/store'),
            import(/* webpackChunkName: "InStoreProductListManager" */ 'containers/InStoreProductListManagerContainer'),
            import(/* webpackChunkName: "TopNotificationBar" */ 'containers/InStoreProductTopNotificationBarContainer'),
            import(/* webpackChunkName: "InStoreProductActions" */ 'actions/inStoreProductActions'),
            import(/* webpackChunkName: "Reactl10n" */ 'react-l10n'),
            import(/* webpackChunkName: "MainLanguage" */ 'lang/main'),
        ]).then(
            ([
                { default: React },
                { default: ReactDOM },
                ReactRedux,
                Store,
                { default: InStoreProductListManager },
                { default: TopNotificationBar },
                InStoreProductActions,
                { LocalizationProvider },
                { getResources },
            ]) => {
                const { Provider } = ReactRedux;
                const { store } = Store;
                const { requestInStoreCategories } = InStoreProductActions;

                ReactDOM.render(
                    <LocalizationProvider resources={getResources()}>
                        <Provider store={store}>
                            <InStoreProductListManager />
                        </Provider>
                    </LocalizationProvider>,
                    el
                );

                // Request Categories
                store.dispatch(requestInStoreCategories());

                // Top Notification Bar
                let topNotificationBar = document.createElement('div');
                topNotificationBar.setAttribute(
                    'id',
                    'in-store-products-notification'
                );
                document.body.appendChild(topNotificationBar);

                ReactDOM.render(
                    <LocalizationProvider resources={getResources()}>
                        <Provider store={store}>
                            <TopNotificationBar />
                        </Provider>
                    </LocalizationProvider>,
                    topNotificationBar
                );
            }
        );
    }
};
const initInStoreProductForm = () => {
    const el = document.getElementById('in-store-product-form');
    if (el) {
        Promise.all([
            import(/* webpackChunkName: "React" */ 'react'),
            import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
            import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
            import(/* webpackChunkName: "Store" */ 'store/store'),
            import(/* webpackChunkName: "InStoreProductForm" */ 'containers/InStoreProductFormContainer'),
            import(/* webpackChunkName: "InStoreProductActions" */ 'actions/inStoreProductActions'),
            import(/* webpackChunkName: "Reactl10n" */ 'react-l10n'),
            import(/* webpackChunkName: "MainLanguage" */ 'lang/main'),
        ]).then(
            ([
                { default: React },
                { default: ReactDOM },
                ReactRedux,
                Store,
                { default: InStoreProductForm },
                InStoreProductActions,
                { LocalizationProvider },
                { getResources },
            ]) => {
                const { Provider } = ReactRedux;
                const { store } = Store;
                const { requestInStoreCategories } = InStoreProductActions;

                ReactDOM.render(
                    <LocalizationProvider resources={getResources()}>
                        <Provider store={store}>
                            <InStoreProductForm />
                        </Provider>
                    </LocalizationProvider>,
                    el
                );

                // Request Categories
                store.dispatch(requestInStoreCategories());
            }
        );
    }
};
const initProductConfigurator = () => {
    const el = document.getElementById('product-configurator');
    if (el) {
        Promise.all([
            import(/* webpackChunkName: "React" */ 'react'),
            import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
            import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
            import(/* webpackChunkName: "Store" */ 'store/store'),
            import(/* webpackChunkName: "ProductConfigurator" */ 'containers/ProductConfiguratorContainer'),
            import(/* webpackChunkName: "ProductActions" */ 'actions/productActions'),
            import(/* webpackChunkName: "Reactl10n" */ 'react-l10n'),
            import(/* webpackChunkName: "MainLanguage" */ 'lang/main'),
        ]).then(
            ([
                { default: React },
                { default: ReactDOM },
                ReactRedux,
                Store,
                { default: ProductConfigurator },
                ProductActions,
                { LocalizationProvider },
                { getResources },
            ]) => {
                const { Provider } = ReactRedux;
                const { store } = Store;
                const { requestProductCategories } = ProductActions;

                ReactDOM.render(
                    <LocalizationProvider resources={getResources()}>
                        <Provider store={store}>
                            <ProductConfigurator />
                        </Provider>
                    </LocalizationProvider>,
                    el
                );

                // Request Categories
                store.dispatch(requestProductCategories());
            }
        );
    }
};
const initOrderList = () => {
    const el = document.getElementById('order-list');
    if (el) {
        Promise.all([
            import(/* webpackChunkName: "React" */ 'react'),
            import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
            import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
            import(/* webpackChunkName: "Store" */ 'store/store'),
            import(/* webpackChunkName: "OrderList" */ 'containers/OrderListContainer'),
            import(/* webpackChunkName: "Reactl10n" */ 'react-l10n'),
            import(/* webpackChunkName: "MainLanguage" */ 'lang/main'),
        ]).then(
            ([
                { default: React },
                { default: ReactDOM },
                ReactRedux,
                Store,
                { default: OrderList },
                { LocalizationProvider },
                { getResources },
            ]) => {
                const { Provider } = ReactRedux;
                const { store } = Store;

                ReactDOM.render(
                    <LocalizationProvider resources={getResources()}>
                        <Provider store={store}>
                            <OrderList />
                        </Provider>
                    </LocalizationProvider>,
                    el
                );
            }
        );
    }
};
const initInvoiceList = () => {
    const el = document.getElementById('invoice-list');
    if (el) {
        Promise.all([
            import(/* webpackChunkName: "React" */ 'react'),
            import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
            import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
            import(/* webpackChunkName: "Store" */ 'store/store'),
            import(/* webpackChunkName: "InvoiceList" */ 'components/InvoiceList'),
            import(/* webpackChunkName: "Reactl10n" */ 'react-l10n'),
            import(/* webpackChunkName: "MainLanguage" */ 'lang/main'),
            import(/* webpackChunkName: "ReactStripeElements" */ 'react-stripe-elements'),
        ]).then(
            ([
                { default: React },
                { default: ReactDOM },
                ReactRedux,
                Store,
                { default: InvoiceList },
                { LocalizationProvider },
                { getResources },
                { Elements, StripeProvider },
            ]) => {
                const { Provider } = ReactRedux;
                const { store } = Store;

                ReactDOM.render(
                    <LocalizationProvider resources={getResources()}>
                        <Provider store={store}>
                            <StripeProvider apiKey={window.stripePublicKey}>
                                <Elements>
                                    <InvoiceList />
                                </Elements>
                            </StripeProvider>
                        </Provider>
                    </LocalizationProvider>,
                    el
                );
            }
        );
    }
};
const initReceiptList = () => {
    const el = document.getElementById('receipt-list');
    if (el) {
        Promise.all([
            import(/* webpackChunkName: "React" */ 'react'),
            import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
            import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
            import(/* webpackChunkName: "Store" */ 'store/store'),
            import(/* webpackChunkName: "ReceiptList" */ 'components/InvoiceList/ReceiptList'),
            import(/* webpackChunkName: "Reactl10n" */ 'react-l10n'),
            import(/* webpackChunkName: "MainLanguage" */ 'lang/main'),
        ]).then(
            ([
                { default: React },
                { default: ReactDOM },
                ReactRedux,
                Store,
                { default: ReceiptList },
                { LocalizationProvider },
                { getResources },
            ]) => {
                const { Provider } = ReactRedux;
                const { store } = Store;

                ReactDOM.render(
                    <LocalizationProvider resources={getResources()}>
                        <Provider store={store}>
                            <ReceiptList />
                        </Provider>
                    </LocalizationProvider>,
                    el
                );
            }
        );
    }
};

const initCustomerList = () => {
    const el = document.getElementById('customers');
    if (el) {
        Promise.all([
            import(/* webpackChunkName: "React" */ 'react'),
            import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
            import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
            import(/* webpackChunkName: "Store" */ 'store/store'),
            import(/* webpackChunkName: "CustomersContainer" */ 'containers/CustomersContainer'),
            import(/* webpackChunkName: "Reactl10n" */ 'react-l10n'),
            import(/* webpackChunkName: "MainLanguage" */ 'lang/main'),
        ]).then(
            ([
                { default: React },
                { default: ReactDOM },
                ReactRedux,
                Store,
                { default: CustomersContainer },
                { LocalizationProvider },
                { getResources },
            ]) => {
                const { Provider } = ReactRedux;
                const { store } = Store;

                ReactDOM.render(
                    <LocalizationProvider resources={getResources()}>
                        <Provider store={store}>
                            <CustomersContainer />
                        </Provider>
                    </LocalizationProvider>,
                    el
                );
            }
        );
    }
};

const initSpecificCustomerOrderList = () => {
    const el = document.getElementById('customer-order-list');
    if (el) {
        Promise.all([
            import(/* webpackChunkName: "React" */ 'react'),
            import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
            import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
            import(/* webpackChunkName: "Store" */ 'store/store'),
            import(/* webpackChunkName: "SpecificCustomerOrderList" */ 'components/SpecificCustomerOrderList'),
            import(/* webpackChunkName: "Reactl10n" */ 'react-l10n'),
            import(/* webpackChunkName: "MainLanguage" */ 'lang/main'),
        ]).then(
            ([
                { default: React },
                { default: ReactDOM },
                ReactRedux,
                Store,
                { default: SpecificCustomerOrderList },
                { LocalizationProvider },
                { getResources },
            ]) => {
                const { Provider } = ReactRedux;
                const { store } = Store;

                ReactDOM.render(
                    <LocalizationProvider resources={getResources()}>
                        <Provider store={store}>
                            <SpecificCustomerOrderList />
                        </Provider>
                    </LocalizationProvider>,
                    el
                );
            }
        );
    }
};
const initCreditCardList = () => {
    const el = document.getElementById('credit-card-list');
    if (el) {
        Promise.all([
            import(/* webpackChunkName: "React" */ 'react'),
            import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
            import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
            import(/* webpackChunkName: "Store" */ 'store/store'),
            import(/* webpackChunkName: "CreditCardList" */ 'containers/CreditCardListContainer'),
            import(/* webpackChunkName: "Reactl10n" */ 'react-l10n'),
            import(/* webpackChunkName: "MainLanguage" */ 'lang/main'),
        ]).then(
            ([
                { default: React },
                { default: ReactDOM },
                ReactRedux,
                Store,
                { default: CreditCardList },
                { LocalizationProvider },
                { getResources },
            ]) => {
                const { Provider } = ReactRedux;
                const { store } = Store;

                ReactDOM.render(
                    <LocalizationProvider resources={getResources()}>
                        <Provider store={store}>
                            <CreditCardList />
                        </Provider>
                    </LocalizationProvider>,
                    el
                );
            }
        );
    }
};
const initCreditCardForm = () => {
    const el = document.getElementById('credit-card-form');
    if (el) {
        Promise.all([
            import(/* webpackChunkName: "React" */ 'react'),
            import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
            import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
            import(/* webpackChunkName: "Store" */ 'store/store'),
            import(/* webpackChunkName: "CreditCardForm" */ 'containers/CreditCardFormContainer'),
            import(/* webpackChunkName: "Reactl10n" */ 'react-l10n'),
            import(/* webpackChunkName: "MainLanguage" */ 'lang/main'),
        ]).then(
            ([
                { default: React },
                { default: ReactDOM },
                ReactRedux,
                Store,
                { default: CreditCardForm },
                { LocalizationProvider },
                { getResources },
            ]) => {
                const { Provider } = ReactRedux;
                const { store } = Store;

                ReactDOM.render(
                    <LocalizationProvider resources={getResources()}>
                        <Provider store={store}>
                            <CreditCardForm />
                        </Provider>
                    </LocalizationProvider>,
                    el
                );
            }
        );
    }
};
const initPICNumberList = () => {
    const el = document.getElementById('pic-number-list');
    if (el) {
        Promise.all([
            import(/* webpackChunkName: "React" */ 'react'),
            import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
            import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
            import(/* webpackChunkName: "Store" */ 'store/store'),
            import(/* webpackChunkName: "PICNumberList" */ 'containers/PICNumberListContainer'),
            import(/* webpackChunkName: "Reactl10n" */ 'react-l10n'),
            import(/* webpackChunkName: "MainLanguage" */ 'lang/main'),
        ]).then(
            ([
                { default: React },
                { default: ReactDOM },
                ReactRedux,
                Store,
                { default: PICNumberList },
                { LocalizationProvider },
                { getResources },
            ]) => {
                const { Provider } = ReactRedux;
                const { store } = Store;

                ReactDOM.render(
                    <LocalizationProvider resources={getResources()}>
                        <Provider store={store}>
                            <PICNumberList />
                        </Provider>
                    </LocalizationProvider>,
                    el
                );
            }
        );
    }
};
const initPICNumberForm = () => {
    const el = document.getElementById('pic-number-form');
    if (el) {
        Promise.all([
            import(/* webpackChunkName: "React" */ 'react'),
            import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
            import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
            import(/* webpackChunkName: "Store" */ 'store/store'),
            import(/* webpackChunkName: "PICNumberForm" */ 'containers/PICNumberFormContainer'),
            import(/* webpackChunkName: "Reactl10n" */ 'react-l10n'),
            import(/* webpackChunkName: "MainLanguage" */ 'lang/main'),
        ]).then(
            ([
                { default: React },
                { default: ReactDOM },
                ReactRedux,
                Store,
                { default: PICNumberForm },
                { LocalizationProvider },
                { getResources },
            ]) => {
                const { Provider } = ReactRedux;
                const { store } = Store;

                ReactDOM.render(
                    <LocalizationProvider resources={getResources()}>
                        <Provider store={store}>
                            <PICNumberForm />
                        </Provider>
                    </LocalizationProvider>,
                    el
                );
            }
        );
    }
};
export const initSite = () => {
    initMainData();

    initInStoreProductManager();
    initInStoreProductForm();
    initProductConfigurator();
    initCreditCardList();
    initCreditCardForm();
    initPICNumberList();
    initPICNumberForm();
    initCoupons();
    initCouponForm();
    initReferralCoupons();
    initReferralCouponForm();
    initOrderList();
    initInvoiceList();
    initReceiptList();
    initCustomerList();
    initSpecificCustomerOrderList();
};
